import { ReactNode } from "react";
import { Box, FlexProps, Flex } from "@xcorejs/ui";
import * as system from "styled-system";
import { CSSProperties } from "styled-system__css";

export type LeftMenuContainerProps = {
  leftContent: ReactNode;
  rightBorder?: system.ResponsiveValue<CSSProperties["borderRight"]>;
  contentPadding?: system.ResponsiveValue<CSSProperties["paddingLeft"]>;
} & FlexProps;

const LeftMenuContainer = ({ leftContent, children, rightBorder, contentPadding, ...props }: LeftMenuContainerProps) => {
  return (
    <Flex flexDirection={{ _: "column", md: "row" }} {...props}>
      <Flex
        maxWidth={{ _: "100%", md: "30rem" }}
        flex={{ _: "0 0 100%", md: "0 0 30rem" }}
        {...(typeof rightBorder !== undefined && { borderRight: rightBorder as CSSProperties["borderRight"] })}
      >
        {leftContent}
      </Flex>
      <Box
        {...(typeof contentPadding !== undefined && { paddingLeft: contentPadding as CSSProperties["paddingLeft"] })}
        paddingTop="3rem"
        width="100%"
      >
        {children}
      </Box>
    </Flex>
  );
};

LeftMenuContainer.displayName = "LeftMenuContainer";

export default LeftMenuContainer;
